__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/7d2651d/_next/";